// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slide_slide__g3pj8","slideImageWrapper":"Slide_slideImageWrapper__2sEme","slideDown":"Slide_slideDown__2YGeH","slideUp":"Slide_slideUp__3Xd8n"};